import { render, staticRenderFns } from "./CustomerFieldsByCompany.vue?vue&type=template&id=812dc83c&scoped=true"
import script from "./CustomerFieldsByCompany.vue?vue&type=script&lang=js"
export * from "./CustomerFieldsByCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812dc83c",
  null
  
)

export default component.exports